export namespace NewsListStates {
    export function newsListStatesFactory() {
        const newsState = {
            selectType: 'all',
            newsDetail: null
        };
        return newsState;
    }

    export function mutations() {
        return {
            selectNewsListType(state: any, type: string) {
                state.newsList.selectType = type;
            },
            setDetail(state: any, newsItem: any) {
                state.newsDetail = newsItem;
            }
        };
    }
}
